<template>
	<view class="detail">
		<view :class="info.type === 1?'nr head1':'nr head0'">
			<view class="nr-status">
				<text>{{info.statusName|| ''}}</text>
				<view class="nr-status-type1" v-if="info.type === 0">就地寄存</view>
				<view class="nr-status-type"  v-if="info.type === 1">同城寄送</view>
				<view class="nr-status-type1"  v-if="info.type === 1 && info.isUrgent === 0">标速达</view>
				<view class="nr-status-type1"  v-if="info.type === 1 && info.isUrgent === 1">极速达</view>
				<view class="nr-status-type2" v-if="info.exceptionStatus === 1">异常转存</view>
			</view>
			<view class="item" style="padding: 10rpx;" v-if="info.type ===1 && info.status===4">
				<map name="mapAddr"></map>
			</view>
			<view class="item">
				<view class="addr">
					<view class="addr-item">
						<view class="ji bg">寄</view>
						<view class="xiantiao"></view>
						<view class="addr-item-top">
							<text>{{info.depositShopName || ''}}</text>
						</view>
						<text>{{info.depositShopAddress || ''}}  </text>
					</view>
					<view class="addr-item" v-if="info.type === 1">
						<view class="ji bg1">收</view>
						<view class="addr-item-top">
							<text>{{info.takeShopName || info.takeLocation || ''}}</text> 
						</view>
						<text>{{info.takeShopAddress || ''}}  </text>
					</view>
				</view>
				<view class="item-x"></view>
				<view class="item-list">
					<view class="item-list-row">
						<view class="item-form-label">收件人</view>
						<view class="item-form-val">{{info.takeUser || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">收件人电话</view>
						<view class="item-form-val">{{info.takePhone || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">预计到店时间</view>
						<view class="item-form-val">{{info.expectedDepositTime || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">预计取件时间</view>
						<view class="item-form-val">{{info.expectedTakeTime || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">物品名称</view>
						<view class="item-form-val">{{info.goodTypeName || ''}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label">物品照片</view>
						<view class="item-form-list" v-if="info.orderImages && info.orderImages.length">
							<view class="item-form-list-row" v-for="(item,index) in info.orderImages" key="item">
								<image :src="item" mode="widthFix" @click="previewImage(info.orderImages,index)"></image>
							</view> 
						</view>
					</view>
				</view>
				<view class="addr" v-if="info.driverPhone">
					<view class="addr-item">
						<view class="ji bg">送</view>
						<view class="addr-item-top">
								<text class=" txt-d">司机：{{info.driverName || '战神'}} </text>
						</view>
						<view class='addr-link'>
							<image style="margin-right: 10rpx;" @click="contactPhoneDo(info.driverPhone)" src="/static/icon/ic_call@2x.png" mode="widthFix"  ></image>
							<text class=" txt-d1">联系司机</text>
						</view>
						
					</view>
				</view>
			</view>
			<view class="item" v-if="info.detailList">
				<view class="xl">
					<view v-for="goods in info.detailList " :key="goods.luggageName" class="xl-item">
						<view class="xl-item-top">
							<text>{{ goods.luggageName ||'' }}</text>
							<text>¥{{((goods.subtotal || 0)/100).toFixed(2) }}</text>
						</view>
						<view class="xl-item-bottom">
							<text>{{ goods.luggageDetail || '' }}</text>
							<text>x{{ goods.num || 1}}</text>
						</view>
					</view> 
				</view>
				<view class="item-x"></view>
				<view class="item-list">
					<view class="item-list-row">
						<view class="item-form-label" style="color: #333333; font-size: 28rpx;">保价金额</view>
						<view class="item-form-val" style="color: #333333; font-size: 24rpx;">¥{{((info.declaredAmount || 0)/100).toFixed(2)}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label" style="color: #333333; font-size: 28rpx;">行李保费</view>
						<view class="item-form-val" style="color: #333333; font-size: 24rpx;">¥{{((info.declaredFee || 0)/100).toFixed(2)}}</view>
					</view>
					<view class="item-list-row">
						<view class="item-form-label" style="color: #222222; font-size: 30rpx; font-weight: 600;">实付款</view>
						<view class="item-form-val price" style="color: #FE2C2E; font-size: 36rpx;">{{((info.actualPayAmount || 0)/100).toFixed(2)}}</view>
					</view>
				</view>
			</view>
			<view class="tips" v-if="info.overdueStatus !==0 &&info.overdueStatus !==2">
				<image src="/static/icon/ic_waring@2x.png" mode="widthFix"></image>
				<text  v-if="info.overdueStatus ===1">已超过取件时间，已产生超时费用：¥{{((info.overdueFee || 0)/100).toFixed(2)}}元</text> 
				<text  v-if="info.overdueStatus ===3">已超过取件时间，等待客户支付超时费用：¥{{((info.overdueFee || 0)/100).toFixed(2)}}元</text>
				<text  v-if="info.overdueStatus ===4">超过取件时间，已支付超时费用：¥{{((info.overdueFee || 0)/100).toFixed(2)}}元</text>
			</view> 
			<view class="item">
				<view class="item-title">订单信息</view>
				<view class="item-infos">
					<view class="item-infos-item">
						<view class="item-infos-item-left">订单编号：</view>
						<view class="item-infos-item-right">
							<text>{{info.code ||''}}</text>
							<image src="/static/icon/ic_cppy@2x.png" mode="widthFix" @tap="copyCode(info.code||'')"></image>
						</view>
					</view>
					<view class="item-infos-item">
						<view class="item-infos-item-left">创建时间：</view>
						<view class="item-infos-item-right">
							<text>{{info.createTime ||''}}</text>
						</view>
					</view>
					<view class="item-infos-item" v-if="info.payTime">
						<view class="item-infos-item-left">支付时间：</view>
						<view class="item-infos-item-right">
							<text>{{info.payTime ||''}}</text>
						</view>
					</view>
					<view class="item-infos-item">
						<view class="item-infos-item-left">支付方式：</view>
						<view class="item-infos-item-right">
							<text>微信支付</text>
						</view>
					</view>
					<view class="item-infos-item" v-if="info.outTradeNo">
						<view class="item-infos-item-left">交易单号：</view>
						<view class="item-infos-item-right">
							<text>{{info.outTradeNo || ''}}</text>
						</view>
					</view>
					<view class="item-infos-item">
						<view class="item-infos-item-left">订单备注：</view>
						<view class="item-infos-item-right">
							<text>{{info.remark || ''}}</text>
						</view>
					</view>
				</view>
			</view>
			<view style="width: 100%; height: calc(210rpx + env(safe-area-inset-bottom));"></view>
		</view>
		<view class="footer" >
			<view class="footer-btns">
				<view class="btn you"  v-if="info.status >0 || info.status <=7  "   @click="printerOrder1()" >打印标签</view>
				<view class="btn you"  v-if="info.status ===1 ||info.status ===4  "   @click="confirmWriteOff()"  >收件核销</view>
				<view class="btn you" v-if="info.status ===5 &&(info.overdueStatus ==0 || info.overdueStatus == 1)"  @click="show2=true" >确认到店</view>
				<view class="btn you" v-if="info.status ===5 && (info.overdueStatus == 4 || info.overdueStatus == 2)"  @click="confirmPickup()"  >取件核销</view>
<!-- 				<view class="btn you" v-if="info.status ===4"  @click="show3=true"  >确认收件</view>
 -->			</view>
		</view>
		<u-popup :show="show0" round="15" :safeAreaInsetBottom="false" mode="bottom">
			<view class="tc" style="width: 100%;">
				<view class="tc-contemt">
					<view class="tc-contemt-title" >确认收件</view>
					<view class="input-c">
						<view class="input-label">拍照收件<text style="color: red;" v-if="info.type === 1">*</text><text style="color: #666666;">（最多3张照片）</text></view>
						<view class="upload-row">
							<view class="upload-box" @click="chooseAndUploadImage(3)">
								<view class="upload-plus">+</view>
								<text class="upload-text">上传照片</text>
							</view>
							<view v-for="(item, index) in photoList" :key="index" class="photo-box">
								<image class="photo-image" :src="item.url" mode="aspectFill"></image>
								<text class="photo-delete" @click="deleteImage(index)">删除</text>
							</view>
						</view>
						<view class="input-label">备注信息</view>
						<view class="textarea-box">
							<view class="textarea-placeholder-wrap">
								<view class="textarea-icon"></view>
								<textarea v-model="form.remark" class="textarea" maxlength="200" placeholder="请输入备注信息" placeholder-class="textarea-placeholder"></textarea>
							</view>
							<text class="textarea-count">{{ form.remark.length }}/200</text>
						</view>
					</view>
				</view>
				
				<view class="tc-btn">
					<view class="tc-btn-item" @click="show0 = false;">取消 </view>
					<view class="tc-btn-item" style="background: #004096;border-radius: 0;color:#ffffff;" @click="shopVerifyOrderDo">确认收件</view>
				</view>
			</view>
		</u-popup>
		<u-popup :show="show1" round="15" :safeAreaInsetBottom="false" mode="bottom">
			<view class="tc" style="width: 100%;">
				<view class="tc-contemt">
					<view class="tc-contemt-title" >确认取件</view>
					<view class="input-c">
						<view class="input-label">拍照取件<text style="color: red;" v-if="info.type === 1">*</text><text style="color: #666666;">（最多3张照片）</text></view>
						<view class="upload-row">
							<view class="upload-box" @click="chooseAndUploadImage1(3)">
								<view class="upload-plus">+</view>
								<text class="upload-text">上传照片</text>
							</view>
							<view v-if="photoList1" v-for="(item, index) in photoList1" :key="index" class="photo-box">
								<image class="photo-image" :src="item.url" mode="aspectFill"></image>
								<text class="photo-delete" @click="deleteImage1(index)">删除</text>
							</view>
						</view>
						<view class="input-label">备注信息</view>
						<view class="textarea-box">
							<view class="textarea-placeholder-wrap">
								<view class="textarea-icon"></view>
								<textarea v-model="form1.remark" class="textarea" maxlength="200" placeholder="请输入备注信息" placeholder-class="textarea-placeholder"></textarea>
							</view>
							<text class="textarea-count">{{ form1.remark.length }}/200</text>
						</view>
					</view>
				</view>
				
				<view class="tc-btn">
					<view class="tc-btn-item" @click="show1 = false;">取消 </view>
					<view class="tc-btn-item" style="background: #004096;border-radius: 0;color:#ffffff;" @click="storeOutOrderDo">确认取件</view>
				</view>
			</view>
		</u-popup>
		<u-popup :show="show3" round="15" :safeAreaInsetBottom="false" mode="bottom">
			<view class="tc" style="width: 100%;">
				<view class="tc-contemt">
					<view class="tc-contemt-title" >确认收件</view>
					<view class="input-c">
						<view class="input-label">拍照收件<text style="color: red;">*</text><text style="color: #666666;">（最多3张照片）</text></view>
						<view class="upload-row">
							<view class="upload-box" @click="chooseAndUploadImage3(3)">
								<view class="upload-plus">+</view>
								<text class="upload-text">上传照片</text>
							</view>
							<view v-if="photoList1" v-for="(item, index) in photoList3" :key="index" class="photo-box">
								<image class="photo-image" :src="item.url" mode="aspectFill"></image>
								<text class="photo-delete" @click="deleteImage3(index)">删除</text>
							</view>
						</view>
						<view class="input-label">备注信息</view>
						<view class="textarea-box">
							<view class="textarea-placeholder-wrap">
								<view class="textarea-icon"></view>
								<textarea v-model="form3.remark" class="textarea" maxlength="200" placeholder="请输入备注信息" placeholder-class="textarea-placeholder"></textarea>
							</view>
							<text class="textarea-count">{{ form3.remark.length }}/200</text>
						</view>
					</view>
				</view>
				
				<view class="tc-btn">
					<view class="tc-btn-item" @click="show3 = false;">取消 </view>
					<view class="tc-btn-item" style="background: #004096;border-radius: 0;color:#ffffff;" @click="storeOutOrderDo">确认取件</view>
				</view>
			</view>
		</u-popup>
		<u-popup :show="show2" round="15" :safeAreaInsetBottom="false" mode="bottom">
			<view class="tc" style="width: 100%;">
				<view class="tc-contemt" > 
				<view class="tc-contemt-title">确认到店</view>
				<view class="tc-contemt-nr">
					是否确认客户已到店取件？
				</view>
				<view class="tc-btn" style="margin-top: 50rpx;">
					<view class="tc-btn-item" @click="show2 = false;">取消</view>
					<view class="tc-btn-item" style="background: #004096;border-radius: 0;color:#ffffff;" @click="confirmArrivedOrderDo">确认到店</view>
				</view>
					</view>
			</view>
		</u-popup>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	import drawQrcode from 'weapp-qrcode'

	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight', 'latitude', 'longitude'])
		},
		data() {
			return {
				id:null,
				show1:false,
				show0:false,
				loading:false,
				show3:false,
				show2:false,
				info:{},
				inRadius: false,
				// latitude: null,
				// longitude: null,
				photoList:[],
				photoList1:[],
				photoList3:[],
				form:{
					remark: "",
					orderId: null,
					images:[]
				},
				form1:{
					remark: "",
					orderId: null,
					images:[]
				},
				form3:{
					remark: "",
					orderId: null,
					images:[]
				}
			}
		},
		onLoad(options) {
			this.info={} 
			this.show2=false
			this.loading=false
			this.show1=false
			this.show0=false
			this.show3=false
			this.id = options.id
			this.form.orderId=this.id
			
			this.photoList=[],
			this.photoList1=[],
			this.photoList3=[],
			this.form={
				remark: "",
				orderId: this.id,
				images:[]
			}
			this.form1={
				remark: "",
				orderId: this.id,
				images:[]
			}
			this.form3={
				remark: "",
				orderId: this.id,
				images:[]
			}
			this.checkRadiusAndGetDetail()
		},
		methods:{
			async confirmPickup() {
				await this.checkRadiusAndGetDetail()
				if (!this.inRadius) {
					uni.showToast({
						title: '您当前位置与收货地址距离超出范围，请在地址附近重新拍照',
						icon: 'none'
					})
					return
				}
				this.show1 = true
			},
			async confirmWriteOff() {
				await this.checkRadiusAndGetDetail()
				if (!this.inRadius) {
					uni.showToast({
						title: '您当前位置与收货地址距离超出范围，请在地址附近重新拍照',
						icon: 'none'
					})
					return
				}
				this.show0 = true
			},
			async checkRadiusAndGetDetail() {
				return new Promise((resolve) => {
					uni.getLocation({
						type: 'gcj02',
						success: async (res) => {
							const radiusRes = await this.$u.api.checkShopOperationRadius({
								lat: res.latitude,
								lng: res.longitude,
								orderId: this.id
							})
							if (radiusRes.code === 200) {
								if (!radiusRes.data) {
									uni.showToast({
										title: '您当前位置与收货地址距离超出范围，请在地址附近重新拍照',
										icon: 'none'
									})
								}
								this.inRadius = radiusRes.data
							}
							this.getOrderDetail0()
							resolve()
						},
						fail: () => {
							uni.showToast({
								title: '请先打开位置服务',
								icon: 'none'
							})
							this.getOrderDetail0()
							resolve()
						}
					})
				})
			},
			// // 定位
			// positioning() {
			// 	var that = this;
			// 	uni.getLocation({
			// 		type: 'gcj02',
			// 		highAccuracyExpireTime: 3000,
			// 		isHighAccuracy: true,
			// 		success: function (addr) {
			// 			if(!addr){
			// 				return
			// 			}
			// 			that.latitude=addr.latitude
			// 			that.longitude=addr.longitude
			// 		}
			// 	});
			// },
			async chooseAndUploadImage(maxCount = 3) {
				const currentCount = this.form.images.length
				const remainingCount = maxCount - currentCount
				if (remainingCount <= 0) {
					uni.showToast({
						title: `最多上传${maxCount}张图片`,
						icon: 'none'
					})
					return
				}
				var that = this
				uni.chooseImage({
					count: remainingCount,
					sizeType: ['compressed'],
					sourceType: ['album', 'camera'],
					success: async (res) => {
						const tempFilePaths = res.tempFilePaths
						uni.showLoading({
							title: '上传中...',
							mask: true
						})
						try {
							const uploadResults = await that.uploadFiles(tempFilePaths, maxCount)
							const addrs = uploadResults.map(item => item.imgaddr)
							const fullPaths = uploadResults.map(item => item.url || item.path || item)
							that.photoList = [...that.photoList, ...fullPaths.map(url => ({ url }))]
							that.form.images = [...that.form.images, ...addrs]
							uni.hideLoading()
							uni.showToast({
								title: '上传成功',
								icon: 'success'
							})
						} catch (error) {
							uni.hideLoading()
						}
					}
				})
			},
			async chooseAndUploadImage1(maxCount = 3) {
				const currentCount = this.form1.images.length
				const remainingCount = maxCount - currentCount
				if (remainingCount <= 0) {
					uni.showToast({
						title: `最多上传${maxCount}张图片`,
						icon: 'none'
					})
					return
				}
				var that = this
				uni.chooseImage({
					count: remainingCount,
					sizeType: ['compressed'],
					sourceType: ['album', 'camera'],
					success: async (res) => {
						const tempFilePaths = res.tempFilePaths
						uni.showLoading({
							title: '上传中...',
							mask: true
						})
						try {
							const uploadResults = await that.uploadFiles(tempFilePaths, maxCount)
							const addrs = uploadResults.map(item => item.imgaddr)
							const fullPaths = uploadResults.map(item => item.url || item.path || item)
							that.photoList1 = [...that.photoList1, ...fullPaths.map(url => ({ url }))]
							that.form1.images = [...that.form1.images, ...addrs]
							uni.hideLoading()
							uni.showToast({
								title: '上传成功',
								icon: 'success'
							})
						} catch (error) {
							uni.hideLoading()
						}
					}
				})
			},
			async chooseAndUploadImage3(maxCount = 3) {
				const currentCount = this.form3.images.length
				const remainingCount = maxCount - currentCount
				if (remainingCount <= 0) {
					uni.showToast({
						title: `最多上传${maxCount}张图片`,
						icon: 'none'
					})
					return
				}
				var that = this
				uni.chooseImage({
					count: remainingCount,
					sizeType: ['compressed'],
					sourceType: ['album', 'camera'],
					success: async (res) => {
						const tempFilePaths = res.tempFilePaths
						uni.showLoading({
							title: '上传中...',
							mask: true
						})
						try {
							const uploadResults = await that.uploadFiles(tempFilePaths, maxCount)
							const addrs = uploadResults.map(item => item.imgaddr)
							const fullPaths = uploadResults.map(item => item.url || item.path || item)
							that.photoList3 = [...that.photoList1, ...fullPaths.map(url => ({ url }))]
							that.form3.images = [...that.form1.images, ...addrs]
							uni.hideLoading()
							uni.showToast({
								title: '上传成功',
								icon: 'success'
							})
						} catch (error) {
							uni.hideLoading()
						}
					}
				})
			},
			deleteImage(index) {
				this.photoList.splice(index, 1)
				this.form.images.splice(index, 1)
			},
			deleteImage1(index) {
				this.photoList1.splice(index, 1)
				this.form1.images.splice(index, 1)
			},
			 
			 deleteImage3(index) {
			 	this.photoList3.splice(index, 1)
			 	this.form3.images.splice(index, 1)
			 },
			  
			async uploadFiles(filePaths, maxCount = 9) {
				if (!filePaths || filePaths.length === 0) {
					return []
				}
				var that =this
				const limitedPaths = filePaths.slice(0, maxCount)
				const uploadTasks = limitedPaths.map(filePath => {
					return new Promise((resolve, reject) => {
						uni.uploadFile({
							url: this.$baseUrl + '/web/public/upload',
							filePath: filePath,
							name: 'file',
							formData: {
								folder: 'orders',
								latitude: that.latitude || 0,
								longitude: that.longitude|| 0
							},
							success: (res) => {
								if (res.statusCode === 200) {
									const data = JSON.parse(res.data)
									if (data.code === 200) {
										resolve(data.data)
									} else {
										reject(new Error(data.msg || '上传失败'))
									}
								} else {
									reject(new Error('上传失败'))
								}
							},
							fail: (err) => {
								reject(err)
							}
						})
					})
				})
				try {
					const results = await Promise.all(uploadTasks)
					return results
				} catch (error) {
					uni.showToast({
						title: '上传失败',
						icon: 'none'
					})
					throw error
				}
			},
			 
			previewImage(images,index = 0) {
				uni.previewImage({
					current: index, 
					urls: images  
				});
			},
			cancelOrder(item){
				this.showCancel = !this.showCancel
			}, 
			async confirmArrivedOrderDo(){
				var that =this
				let res = await that.$u.api.confirmArrivedOrder(this.form);
				if (res.code === 200 ) { 
					uni.showToast({
						title: '操作成功',
						icon: 'success'
					})
					uni.$emit('updateOrder',{info:this.info,delete:0})
					setTimeout(function(){
						 that.getOrderDetail()
					},1000) 
				} 
			}, 
			async storeOutOrderDo(){
				var that =this
				if (this.info.type === 1) {
					if (!this.form1.images || this.form1.images.length == 0) {
						uni.showToast({
							title: '请上传取件图片',
							icon: 'warn'
						})
						return
					}
				} else {
					if (!this.form1.images || this.form1.images.length == 0) {
						delete this.form1.images
					}
				}
				let res = await that.$u.api.storeOutOrder(this.form1);
				if (res.code === 200 ) { 
					uni.showToast({
						title: '核验成功',
						icon: 'success'
					})
					// uni.$emit('updateOrder',{info:this.info,delete:0})
					setTimeout(function(){
						 that.getOrderDetail()
					},1000) 
				} 
			}, 
			async printerOrder(){
				try{
					var that =this
					 that.$u.api.printOrderLabel({ orderId: this.id }).then(res=>{})
				}catch(e){
				} 
				
			},
			async printerOrder1(){
				if(this.loading){
					return
				}
				this.loading =true
				try{
					var that =this
					 that.$u.api.printOrderLabel({ orderId: this.id }).then(res=>{
						 if (res.code === 200 ) {
							 uni.showToast({
							 	title:'发起打印请求成功',
								icon:'none'
							 })
						 } 
						 that.loading =false
					 })
				}catch(e){
					this.loading =false
				} 
				
			},
			async shopVerifyOrderDo(){
				var that =this
				if (this.info.type === 1) {
					if (!this.form.images || this.form.images.length == 0) {
						uni.showToast({
							title: '请上传收件图片',
							icon: 'warn'
						})
						return
					}
				} else {
					if (!this.form.images || this.form.images.length == 0) {
						delete this.form.images
					}
				}
				let res = await that.$u.api.shopVerifyOrder(this.form);
				if (res.code === 200 ) { 
					uni.showToast({
						title:'核验成功',
						icon: 'success'
					})
					  uni.$emit('updateOrder',{info:this.info,delete:0})
					  if (that.info.status === 1) {
						that.printerOrder()
					  }
					 setTimeout(function(){
						 that.getOrderDetail()
					 },1000) 
				} 
			}, 
			async  getOrderDetail(){
				var that =this 
				this.show2=false
				this.show1=false
				this.show0=false
				let res = await this.$u.api.shopOrderDetail( {orderId:this.id} )
				if (res.code === 200) { 
					this.info = res.data 
				} 
			},
			async  getOrderDetail0(){
				var that =this 
				this.show2=false
				this.show1=false
				this.show0=false
				let res = await this.$u.api.shopOrderDetail( {orderId:this.id} )
				if (res.code === 200) { 
					this.info = res.data 
					if(res.data.status === 1 ||res.data.status === 4 ){
						that.actionType = 0
						if (this.inRadius) {
							that.show0 = true
						}
						//info.overdueStatus ==0 || info.overdueStatus == 1
					}else if(res.data.status === 5 && (res.data.overdueStatus ==4 || res.data.overdueStatus == 2)){
						that.actionType = 1
						if (this.inRadius) {
							that.show1 = true
						}
					}else if(res.data.status === 5 && (res.data.overdueStatus ==0 || res.data.overdueStatus == 1)){
						that.actionType = 1
						if (this.inRadius) {
							that.show2 = true
						}
					}else{
						/* uni.showToast({
							title:'订单状态已流转，当前无法核验！',
							icon:'error'
						}) */
					}
				} 
			}
		}
	}
</script>
<style>
	page {
		background-color: #F8F9FB;
	}
</style>
<style lang="scss" scoped>
	.input-c{
		display: flex;flex-direction: column;
		margin-top: 32rpx;
		.input-label{
			font-weight: 600;
			margin-top: 32rpx;
			font-size: 30rpx;
			color: #222222;
			line-height: 42rpx;
			text-align: left;
			font-style: normal;
		}
		.input-tip{
			font-weight: 400;
			font-size: 24rpx;
			color: #999999;
			line-height: 34rpx;
			text-align: left;
			font-style: normal;
		}
		.upload-row {
			margin-top: 16rpx;
			display: flex;
			align-items: flex-start;
			gap: 10rpx;
			margin-bottom: 22rpx;
		}
		
		.upload-box,
		.photo-box {
			width: 122rpx;
			height: 122rpx;
			border-radius: 0;
			overflow: hidden;
			position: relative;
			box-sizing: border-box;
		}
		
		.upload-box {
			border: 1rpx dashed #c8ccd4;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}
		
		.upload-plus {
			font-size: 54rpx;
			line-height: 1;
			color: #999999;
		}
		
		.upload-text {
			margin-top: 8rpx;
			font-size: 24rpx;
			color: #999999;
		}
		
		.photo-image {
			width: 100%;
			height: 100%;
		}
		
		.photo-delete {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			height: 32rpx;
			line-height: 32rpx;
			text-align: center;
			font-size: 22rpx;
			color: #ffffff;
			background: rgba(0, 0, 0, 0.45);
		}
		
		
		.textarea-box {
			background: #f6f8fb;
			border-radius: 18rpx;
			padding: 18rpx 18rpx 16rpx;
			box-sizing: border-box;
		}
		
		.textarea-placeholder-wrap {
			display: flex;
			align-items: flex-start;
		}
		
		.textarea-icon {
			width: 26rpx;
			height: 26rpx;
			border: 2rpx solid #b9bec7;
			margin-top: 8rpx;
			margin-right: 12rpx;
			box-sizing: border-box;
			position: relative;
		}
		
		.textarea-icon::before,
		.textarea-icon::after {
			content: '';
			position: absolute;
			background: #b9bec7;
		}
		
		.textarea-icon::before {
			width: 20rpx;
			height: 2rpx;
			left: 2rpx;
			top: 11rpx;
			transform: rotate(-45deg);
		}
		
		.textarea-icon::after {
			width: 2rpx;
			height: 12rpx;
			right: 4rpx;
			top: 3rpx;
			transform: rotate(-45deg);
		}
		
		.textarea {
			flex: 1;
			min-height: 260rpx;
			font-size: 28rpx;
			line-height: 1.6;
			color: #333333;
			background: transparent;
		}
		
		.textarea-placeholder {
			font-size: 28rpx;
			color: #b9bec7;
		}
		
		.textarea-count {
			display: block;
			margin-top: 8rpx;
			text-align: right;
			font-size: 20rpx;
			color: #999999;
		}
		
	}
	.detail {
		width: 100%;
		.tips {
			width: 100%;
			height: 80rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			background: #FFE9E9;
			position: fixed;
			bottom: calc(30rpx + env(safe-area-inset-bottom));
			left: 0;
			display: flex;
			align-items: center;
			image {
				width: 28rpx;
				height: 28rpx;
				margin-right: 16rpx;
			}
			text {
				font-weight: 400;
				font-size: 26rpx;
				color: #FF0000;
			}
		}
		.footer {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			padding: 0 30rpx;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			z-index: 9;
			background-color: #ffffff;
			.footer-btns {
				width: 100%;
				height: 100rpx;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.kong {
					border: 1rpx solid #B2B2B2;
					font-weight: 400;
					font-size: 28rpx;
					color: #666666;
				}
				.you {
					background: #10B2FA;
					font-weight: 400;
					font-size: 28rpx;
					color: #FFFFFF;
				}
				.btn {
					width: 160rpx;
					height: 64rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 32rpx;
					margin-left: 20rpx;
				}
			}
		}
		.head0{
			background: #1ba8fa;
		}
		.head1{
			background: #E4730B;
		}
		.head {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 9;
			.head-nav {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				image {
					width: 48rpx;
					height: 48rpx;
				}
				text {
					font-weight: 500;
					font-size: 32rpx;
					color: #FFFFFF;
				}
			}
		}
		.nr {
			width: 100%;
			height: 264rpx;
			padding: 22rpx 30rpx;
			box-sizing: border-box;
			// background-color: #E4730B;
			.nr-status {
				display: flex;
				align-items: baseline;
				text {
					font-weight: 600;
					font-size: 36rpx;
					color: #FFFFFF;
					margin-right: 16rpx;
				}
				.nr-status-type {
					width: 154rpx;
					height: 38rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FFFFFF;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #FA8010;
				}
				.nr-status-type1 {
					width: 158rpx;
					height: 38rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FFFFFF;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #10B2FA;
					margin-left: 16rpx;
				}
				.nr-status-type2 {
					width: 158rpx;
					height: 38rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #FFFFFF;
					border-radius: 8rpx;
					font-weight: 400;
					font-size: 24rpx;
					color: #FF0000;
					margin-left: 16rpx;
				}
			}
			.nr-desc {
				font-weight: 400;
				font-size: 26rpx;
				color: #FFFFFF;
				margin-top: 12rpx;
			}
			.item {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-top: 30rpx;
				map {
					width: 100%;
					height: 362rpx;
					border-radius: 16rpx;
				}
				.addr {
					width: 100%;
					display: flex;
					flex-direction: column;
					.addr-link{
						position: absolute;
						    top: 10rpx;
						    right:0px;
						    display: inline-block;
					}
					.addr-item {
						padding-left: 58rpx;
						box-sizing: border-box;
						position: relative;
						margin-bottom: 40rpx;
						&:last-child {
							margin-bottom: 0 !important;
						}
						.txt-d{
							font-weight: 400  !important;
							font-size: 30rpx  !important;
							color: #333333;
							line-height: 42rpx;
							text-align: left;
							font-style: normal;
						}
						.txt-d1{
							font-weight: 400  !important;
							font-size: 26rpx !important;
							color: #333333;
							line-height: 36rpx;
							text-align: left;
							font-style: normal;
						}
						image{
							width: 22rpx;
							margin-left: 22rpx;
						}
						.bg {
							background: #10B2FA;
						}
						.bg1 {
							background-color: #FA8010;
						}
						.xiantiao {
							width: 2rpx;
							height: 100%;
							position: absolute;
							top: 24px;
							left: 20rpx;
							border-right: 2rpx dashed #E5E5E5;
						}
						.ji {
							position: absolute;
							top: 10rpx;
							left: 4rpx;
							width: 40rpx;
							height: 40rpx;
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 50%;
							font-weight: 400;
							font-size: 26rpx;
							color: #FFFFFF;
						}
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
							margin-top: 10rpx;
						}
						.addr-item-top {
							display: flex;
							align-items: center;
							text {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							image {
								width: 13rpx;
								margin-left: 12rpx;
							}
						}
					}
				}
				.xl {
					width: 100%;
					.xl-item {
						width: 100%;
						margin-bottom: 26rpx;
						&:last-child {
							margin: 0 !important;
						}
						.xl-item-top {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							text {
								font-weight: 600;
								font-size: 28rpx;
								color: #333333;
							}
						}
						.xl-item-bottom {
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-top: 12rpx;
							text {
								font-weight: 400;
								font-size: 24rpx;
								color: #8C939F;
							}
						}
					}
				}
				.comment{
					width: 100%;
					display: flex;
					flex-direction: column;
					.comment-top {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							&:nth-child(2) {
								font-weight: 500;
								font-size: 36rpx;
								color: #FE2C2E;
								&:before {
									content: "￥";
									font-weight: 500;
									font-size: 24rpx;
									color: #FE2C2E;
								}
							}
						}
					}
					.comment-score{
						// font-weight: 600;
						font-size: 28rpx;
						color: #333333;
						margin: 10rpx 0;
						display: flex;
						width: 100%;
						.score-item{
							flex:1;
							margin: 20rpx 0;
						}
					}
					.comment-row{
						display: flex;
						flex-wrap: wrap;
						.comment-image {
							margin: 10rpx;
							width: 100rpx;
							height: 100rpx;
							border-radius: 8rpx;
							border:1px solid #f2f2f2;
							overflow: hidden;
							image {
								width: 100%;
							}
						}
					}
					
				}
				.tuikuan {
					width: 100%;
					display: flex;
					flex-direction: column;
					.tuikuan-top {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 30rpx;
								color: #222222;
							}
							&:nth-child(2) {
								font-weight: 500;
								font-size: 36rpx;
								color: #FE2C2E;
								&:before {
									content: "￥";
									font-weight: 500;
									font-size: 24rpx;
									color: #FE2C2E;
								}
							}
						}
					}
					.tuikuan-bottom {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 8rpx;
						text {
							font-weight: 400;
							font-size: 24rpx;
							color: #666666;
						}
					}
				}
				.item-qrcode {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					margin-top: 40rpx;
					image {
						width: 360rpx;
						height: 360rpx;
					}
					text {
						&:nth-child(2) {
							font-weight: 600;
							font-size: 36rpx;
							color: #222222;
							margin-top: 12rpx;
						}
						&:nth-child(3) {
							font-weight: 400;
							font-size: 26rpx;
							color: #999999;
							margin-top: 12rpx;
						}
					}
				}
				.item-x {
					width: 100%;
					height: 1rpx;
					margin: 30rpx 0;
					background-color: #E5E5E5;
				}
				.item-title {
					font-weight: 600;
					font-size: 30rpx;
					color: #222222;
				}
				.item-infos {
					width: 100%;
					margin-top: 18rpx;
					.item-infos-item {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-bottom: 20rpx;
						&:last-child {
							margin: 0 !important;
						}
						.item-infos-item-left {
							font-weight: 400;
							font-size: 24rpx;
							color: #999999;
						}
						.item-infos-item-right {
							display: flex;
							align-items: center;
							text {
								font-weight: 400;
								font-size: 24rpx;
								color: #666666;
							}
							image {
								width: 24rpx;
								margin-left: 16rpx;
							}
						}
					}
				}
				.item-list {
					width: 100%;
					.item-list-row {
						width: 100%;
						margin-bottom: 24rpx;
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						&:last-child {
							margin-bottom: 0 !important;
						}
						.item-form-label {
							width: 300rpx;
							flex-shrink: 0;
							font-weight: 400;
							font-size: 26rpx;
							color: #666666;
						}
						.item-form-val {
							font-weight: 400;
							font-size: 26rpx;
							color: #333333;
						}
						.price {
							&:before {
								content: "￥";
								font-weight: 400;
								font-size: 24rpx;
								color: #FE2C2E;
							}
						}
						.item-form-list {
							max-width: 360rpx;
							display: flex;
							flex-wrap: wrap;
							align-items: center;
							justify-content: space-between;
							.item-form-list-row {
								width: 88rpx;
								height: 88rpx;
								border-radius: 8rpx;
								overflow: hidden;
								image {
									width: 100%;
								}
							}
						}
					}
				}
			}
		}
	}
	
</style>
